<template>
  <b-container class="sendAsMessage">
      <div class="tag-names"></div>
      <div slot="form-fields">
        <textarea
          v-model="description"
          rows="5"
          cols="50"
          class="fieldForType"
          placeholder="Select users using @"
          name="description"
          :class="{ 'is-danger': errors.has('description') }"
          @keydown="tagUser"
        ></textarea>
      </div>
      <div class="user-post-share" v-if="post">
        <b-container class="user-example">
          <b-row v-if="post.customer_details">
            <b-col sm="2">
              <b-img
                class="post-share-one-image"
                left
                :src="post.customer_details.prof_pic"
              />
            </b-col>
            <b-col sm="6">
              <p class="share-modal-username-bold m-0">
                {{ post.customer_details.name }}
              </p>
              <p class="share-modal-user-position m-0">
                {{ post.customer_details.job_title }}
              </p>
              <p class="share-modal-user-job-title m-0">
                {{ post.customer_details.company }}
              </p>
            </b-col>
          </b-row>
          <b-row v-if="post.user_details">
            <b-col cols="2">
              <b-img
                class="post-share-one-image"
                left
                :src="post.user_details.prof_pic"
              />
            </b-col>
            <b-col cols="10">
              <p class="share-modal-username-bold m-0">
                {{ post.user_details.name }}
              </p>
              <p class="share-modal-user-position m-0">
                {{ post.user_details.job_title }}
              </p>
              <p class="share-modal-user-job-title m-0">
                {{ post.user_details.company }}
              </p>
            </b-col>
          </b-row>
        </b-container>
        <div class="user-share-post-div">
          <read-more
            class="user-share-post-text"
            more-str="read more"
            :text="post.content || ''"
            :max-chars="225"
          ></read-more>
          <div v-if="$lodash.get(post, 'media[0].image_field')">
            <img
              class="share-image"
              :src="post.media[0].image_field"
              alt="media"
            />
          </div>
          <div
            class="share-video"
            v-if="post.media.length && post.media[0].video_field"
          >
            <vue-plyr>
              <div
                :data-plyr-provider="getHostName(post.media[0].video_field)"
                :data-plyr-embed-id="post.media[0].video_field"
              ></div>
            </vue-plyr>
          </div>
        </div>
      </div>
      <div>
        <button class="post-btn" @click="sendPost(post.id || $lodash.get(post,'post_details.id'))">
          Send
        </button>
      </div>
    <UserTagSelect v-model="isOpenTag" @tag-user-post="addPostTag" />
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import UserTagSelect from '../../posts/UserTagSelect.vue';

export default {
  name: 'ShareViaMessage',
  props: {
    post: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    UserTagSelect,
  },
  data() {
    return {
      shareTag: '',
      shareTags: [],
      isOpenTag: false,
      description: null,
      tagedUsers: [],
      tagIndex: null,
      chatRoomIds: [],
      page: 1,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
    }),
    postUrl() {
      return `${process.env.VUE_APP_CLIENT_URL}/personal-wall/post/`;
    },
  },
  watch: {
    description(val) {
      if (val === '@'
        || val.slice(this.tagIndex - 1, this.tagIndex + 1) === ' @'
        || val.slice(this.tagIndex - 1, this.tagIndex + 1) === '\n@') {
        this.isOpenTag = true;
      }
    },
  },
  methods: {
    ...mapActions({
      conversationList: 'messages/getConversationList',
      createNewConversation: 'messages/createNewConversation',
      sendMessageViaNodeJSServer: 'messages/sendMessageViaNodeJSServer',
    }),
    async sendPost(postId) {
      this.getChatRoomIds();
      if (this.chatRoomIds.length && this.tagedUsers.length) {
        this.chatRoomIds.forEach((id, index) => {
          const data = {
            chat_room_id: id,
            content: `${this.postUrl + postId}`,
            receiver_id: this.tagedUsers[index].user_id,
          };
          this.sendMessageViaNodeJSServer(data);
        });
      } else if (!this.chatRoomIds.length && this.tagedUsers.length) {
        try {
          this.tagedUsers.forEach(async ({ user_id }) => {
            const { result } = await this.createNewConversation({
              receiver_id: user_id,
            });
            const data = {
              chat_room_id: result.chat_room_id,
              content: `${this.postUrl + postId}`,
              receiver_id: result.receiver_id,
            };
            this.sendMessageViaNodeJSServer(data);
          });
        } catch (err) {
          console.log(err);
        }
      }
      this.$router.push({
        name: 'Messages',
      });
    },
    tagUser(simbol) {
      this.tagIndex = simbol.srcElement.selectionEnd;
    },
    addPostTag(data) {
      this.description = `${this.description.slice(0, this.tagIndex + 1)}${
        data.full_name
      } ${this.description.slice(this.tagIndex + 1)}`;
      this.tagedUsers.push(data);
    },
    getHostName(url) {
      let videoType = 'vimeo';
      const regex = new RegExp(
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?.*/,
      );
      const isYoutubeUrl = regex.test(url);
      if (isYoutubeUrl) {
        videoType = 'youtube';
      }
      return videoType;
    },
    async getChatRoomIds() {
      if (this.tagedUsers.length) {
        await this.conversationList({
          conversationId: '',
          page: this.page,
        }).then((res) => {
          const rooms = this.$lodash.get(res, 'result.docs');
          this.tagedUsers.forEach((user) => {
            rooms.forEach((room) => {
              if (
                room.owner_id === this.$lodash.get(this.userInfo, 'user.id')
                && room.receiver_id === user
              ) {
                this.chatRoomIds.push(res.chat_room_id);
              }
            });
          });
        });
      }
    },
  },
};
</script>

<style scoped src="../css/shareViaMessage.css"></style>
